import IconLogo from '@/assets/images/IconLogo.png';
import IconTemplateA from '@/assets/images/IconTemplateA.png';
import IconTemplateB from '@/assets/images/IconTemplateB.png';
import IconTemplateC from '@/assets/images/IconTemplateC.png';
import IconTemplate1 from '@/assets/images/IconTemplate1.png';
import IconTemplate2 from '@/assets/images/IconTemplate2.png';
import IconVideo from '@/assets/images/IconVideo.svg';
import IconTrash from '@/assets/images/IconTrash.png';
import AddMaterialButton from '@/assets/images/AddMaterialButton.png';
import EmptyMaterialImg from '@/assets/images/EmptyMaterialImg.png';
import NoImage from '@/assets/images/NoImage.svg';
import IconDocs from '@/assets/images/IconDots.png';
import AudioOnIcon from '@/assets/images/AudioOnIcon.svg';
import AudioOffIcon from '@/assets/images/AudioOffIcon.svg';
import IconEmptyMaterial from '@/assets/images/IconEmptyMaterial.png';
import IconEmptyContent from '@/assets/images/IconEmptyContent.png';
import IconEmptyStreamGroup from '@/assets/images/IconEmptyStreamGroup.png';
import IconEmptyMonitor from '@/assets/images/IconEmptyMonitor.svg';
import IconPencil from '@/assets/images/IconPencil.svg';
import IconChromeCast from '@/assets/images/IconChromeCast.svg';

// 定数の定義
export const ICON_LOGO = IconLogo;
export const ICON_DOTS = IconDocs;

export const AUDIO_ON_ICON = AudioOnIcon;
export const AUDIO_OFF_ICON = AudioOffIcon;

export const ICON_EMPTY_MATERIAL = IconEmptyMaterial;
export const ICON_EMPTY_CONTENT = IconEmptyContent;
export const ICON_EMPTY_STREAM_GROUP = IconEmptyStreamGroup;
export const ICON_EMPTY_MONITOR = IconEmptyMonitor;
export const ICON_CHROME_CAST = IconChromeCast;

export const EMPTY_ICON_LIST = [
  ICON_EMPTY_MATERIAL, // 素材未登録アイコンファイル名
  ICON_EMPTY_CONTENT, // コンテンツ未登録アイコンファイル名
  ICON_EMPTY_STREAM_GROUP, // 配信グループ未登録アイコンファイル名
  ICON_EMPTY_MONITOR, // モニター未登録アイコンファイル名
];

export const EDIT_ICON = IconPencil;

export const COPYRIGHT_STR = '©AgVenture Lab. All rights reserved.';
export const HTTP_RESPONSE_CODE = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
};
export const CREATE_CONTENT_PROCESS_NUM = {
  MATERIAL_SELECT: 1,
  CONTENT_CAPTION: 2,
  CONTENT_CONFIRM: 3,
  CONTENT_LIST_PREVIEW: 4,
};
export const EMPTY_PAGE_NUM = {
  MATERIAL: 0,
  CONTENT: 1,
  STREAM_GROUP: 2,
  MONITOR_INFORMATION: 3,
};
export const UPLOAD_STATUS_ID_LIST = {
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded',
  SCHEDULED: 'scheduled',
  CANCEL: 'cancel',
};
export const MATERIAL_UPLORD_STATUS = {
  MATERIAL_UPLOADED: 0,
  THUMBNAIL_UPLOADING: 1,
  MATERIAL_UPLOADING: 2,
  MATERIAL_NOT_REGISTERED: 9,
  THUMBNAIL_UPLOAD_ERR: -1,
  MATERIAL_UPLOAD_ERR: -2,
  MATERIAL_DELETE: -3,
  MATERIAL_REGISTERED_ERR: -9,
};
export const STREAM_GROUP_UPLOAD_STATUS = {
  STREAM_GROUP_UPLOADING: 1,
  STREAM_GROUP_UPLOAD_ERR: -1,
};
export const ICON_TEMPLATE_A = IconTemplateA;
export const ICON_TEMPLATE_B = IconTemplateB;
export const ICON_TEMPLATE_C = IconTemplateC;
export const ICON_TEMPLATE_1 = IconTemplate1;
export const ICON_TEMPLATE_2 = IconTemplate2;

export const HORIZONTAL_TEMPLATES = {
  A: {
    ID: 'A',
    IMAGE: ICON_TEMPLATE_A,
    TITLE: 'テンプレートA',
    DESCRIPTION: '写真1枚と最大200文字の文字が入ります。',
    ALT: 'templateA image',
    IS_CAPTION_IN_TEMPLATE: true,
    TEMPLATE_MATERIAL_LENGTH: 1,
    ASPECT_RATIO_LIST: [16 / 9],
  },
  B: {
    ID: 'B',
    IMAGE: ICON_TEMPLATE_B,
    TITLE: 'テンプレートB',
    DESCRIPTION: '写真2枚と最大200文字の文字が入ります。',
    ALT: 'templateB image',
    IS_CAPTION_IN_TEMPLATE: true,
    TEMPLATE_MATERIAL_LENGTH: 2,
    ASPECT_RATIO_LIST: [8 / 9, 8 / 9],
  },
  C: {
    ID: 'C',
    IMAGE: ICON_TEMPLATE_C,
    TITLE: 'テンプレートC',
    DESCRIPTION: '写真3枚と最大200文字の文字が入ります。',
    ALT: 'templateC image',
    IS_CAPTION_IN_TEMPLATE: true,
    TEMPLATE_MATERIAL_LENGTH: 3,
    ASPECT_RATIO_LIST: [8 / 9, 16 / 9, 16 / 9],
  },
};

export const VERTICAL_TEMPLATES = {
  1: {
    ID: '1',
    IMAGE: ICON_TEMPLATE_1,
    TITLE: 'テンプレート1',
    DESCRIPTION: '写真1枚と最大200文字の文字が入ります。',
    ALT: 'template1 image',
    IS_CAPTION_IN_TEMPLATE: true,
    TEMPLATE_MATERIAL_LENGTH: 1,
    ASPECT_RATIO_LIST: [9 / 16],
  },
  2: {
    ID: '2',
    IMAGE: ICON_TEMPLATE_2,
    TITLE: 'テンプレート2',
    DESCRIPTION: '写真2枚と最大200文字の文字が入ります。',
    ALT: 'template2 image',
    IS_CAPTION_IN_TEMPLATE: true,
    TEMPLATE_MATERIAL_LENGTH: 2,
    ASPECT_RATIO_LIST: [9 / 8, 9 / 8],
  },
};

export const TEMPLATES = {
  ...HORIZONTAL_TEMPLATES,
  ...VERTICAL_TEMPLATES,
};

export const NONE_FRAME_BOTTOM = {
  frameId: 0,
  backFrameName: 'jauser/frames/Frame0.png',
  frontFrameName: null,
  captionOffsetY: 100,
};

export const NONE_FRAME_TOP = {
  frameId: 12,
  backFrameName: 'jauser/frames/Frame0.png',
  frontFrameName: null,
  captionOffsetY: 0,
};

export const CONTENT_CAPTION_COLOR = {
  white: '#FFFFFF',
  black: '#000000',
  red: '#FF0000',
  blue: '#0000FF',
  green: '#21963B',
  yellow: '#FFFF00',
  orange: '#FFA500',
};

export const VIDEO_ICON = IconVideo;
export const TRASH_ICON = IconTrash;
export const ADD_MATERIAL_ICON = AddMaterialButton;
export const EMPTY_MATERIAL_IMG = EmptyMaterialImg;
export const NO_IMG = NoImage;

export const AXIOS_TIMEOUT = 60000;
export const DEFAULT_TIME = 10;
export const UPLOADING_MATERIAL_PHONE_MAXSIZE = 40;
export const UPLOADING_MATERIAL_PC_MAXSIZE = 500;

export const ACCEPT_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'video/quicktime',
  'video/mp4',
];
